export const BNK_STMT_updateJourneyTypeEnumReducer = {
  BNK_STMT_updateJourneyTypeEnum: (state, action) => {
    state.journeyTypeEnum = action.payload;
  },
};
